import { useSuspenseQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { DocumentRequest, Pagination } from '@/types'

type Params = {
  company_key: string
}

export async function readDocumentRequestList({
  company_key,
  ...params
}: Params) {
  const response = await httpClient('accounting-dealer').get<
    Pagination<DocumentRequest>
  >(`/v3/company/${company_key}/document-requests`, {
    params,
  })

  return response.data
}

export function useReadDocumentRequestList({ company_key }: Params) {
  return useSuspenseQuery({
    queryKey: ['document-request-list', company_key],
    queryFn: () => readDocumentRequestList({ company_key }),
    select: (data) => data.data,
  })
}
